import React from 'react';
import Typography from '@material-ui/core/Typography';

const Signature = () => {
  return (
    <>
      <Typography
        color="secondary"
        style={{marginTop: '2rem', textTransform: 'uppercase', fontWeight: 'bold', fontSize: '0.7rem'}}
        variant="subtitle2"
      >
        Made With 💙 by Web Factory
      </Typography>
    </>
  );
}

export default Signature;
